const a = () => ({
  makeCurrentSeason: (o) => ({
    breakpoint: {
      desktop: {
        background: o.breakpoint.desktop.background,
        barColor: o.breakpoint.desktop.barColor,
        barSide: o.breakpoint.desktop.barSide,
        barVersion: o.breakpoint.desktop.barVersion,
        logo: o.breakpoint.desktop.logo
      },
      mobile: {
        background: o.breakpoint.mobile.background,
        barColor: o.breakpoint.mobile.barColor,
        barSide: o.breakpoint.mobile.barSide,
        barVersion: o.breakpoint.mobile.barVersion,
        logo: o.breakpoint.mobile.logo
      }
    },
    name: o.name,
    title: o.title
  })
});
export {
  a as default
};
//# sourceMappingURL=useMakeSeason.js.map
